import _md5 from 'crypto-js/md5';

export function md5(message: string): string {
    return _md5(message).toString();
}
